import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import { Button } from 'primereact/button';
import {
    displayTranlsationPage,
    SaveSurveyTranslation,
    TransactionListByID,
} from '../../Design/design-store/design-actions';
import { displayTranlslationPage } from '../design-store/design-actions-creators';
import { mergeTranslationsWithSurvey } from '../../../../utlities/translation-util';
import './translation.css';

const EditTranslations = () => {
    const dispatch = useDispatch();
    const { surveyDefinitionData, translationList } = useSelector((state) => state.designDetails);
    const { currentSurveyID } = useSelector((state) => state.projectList);
    const { userLoginDetails } = useSelector((state) => state.login);
const [isTranslationsLoaded, setIsTranslationsLoaded] = useState(false);

    // State for merged data
    const [mergedSurveyData, setMergedSurveyData] = useState(surveyDefinitionData);
    // Fetch translations on component mount
    useEffect(() => {
        const fetchTranslations = async () => {
            try {

                const result = await dispatch(
                    TransactionListByID(`${currentSurveyID}/${userLoginDetails.user_id}`)
                );
            } catch (error) {
                console.error('Fetch error:', error);
            } finally {

            }
        };

        fetchTranslations();
    }, [currentSurveyID, userLoginDetails.user_id, dispatch]);
    // Merge translations when data changes
    useEffect(() => {
        if (surveyDefinitionData && translationList?.pages?.length > 0) {
            try {
                const latestTranslation = translationList
                // Directly use the pages array from the translation object
                const translationsToMerge = {
                    pages: latestTranslation?.pages || []
                };
                const mergedData = mergeTranslationsWithSurvey(surveyDefinitionData, translationsToMerge);
                setMergedSurveyData(mergedData);
                setIsTranslationsLoaded(true);
     // console.log('Merged with translations:', mergedData);
                //console.log('Merged Survey Data:', mergedData);
            } catch (error) {
                console.error('Error merging translations:', error);
                setMergedSurveyData(surveyDefinitionData);
            }
        } else {
            setMergedSurveyData(surveyDefinitionData);
        }
    }, [surveyDefinitionData, translationList]);

    // Memoize derived data to prevent unnecessary recalculations
  // Memoize derived data to prevent unnecessary recalculations
    const { updatedData, updatedLanguageList, allTextItems } = useMemo(() => {
//      if (!isTranslationsLoaded) {
//     return {
//       updatedData: [],
//       updatedLanguageList: ['English'],
//       allTextItems: []
//     };
//   }
  // console.log('Merged Survey Data:', mergedSurveyData);
  const updatedData = mergedSurveyData?.pages?.flatMap((page) => page.elements) || [];
       
  const getAllLanguages = () => {
    const languages = new Set(['English']);
    updatedData.forEach(question => {
      if (question.translations) {
        Object.keys(question.translations).forEach(lang => languages.add(lang));
      }
    });
    return Array.from(languages);
  };
// console.log('Merged Survey Data:', mergedSurveyData);
 const updatedLanguageList = mergedSurveyData?.translations?.languages || ['English'];


  const getQuestionTextItems = (question) => {
    // console.log('Processing question:', question);
    const items = [];

    const addTextItem = (type, text, translations, isError = false, optionId = '') => {
      if (!text) return;
      const displayText = typeof text === 'string' ? text : text.text || text.value || '';

      const normalizedTranslations = {};
// console.log('Translations:', translations);
      if (translations) {
        
        Object.entries(translations).forEach(([lang, trans]) => {
          if (!trans) return;

          let transText = '';
          switch (type) {
            case 'Question':
              transText = trans.questionText || '';
              break;
            case 'Question Description':
              transText = trans.questionDescription || '';
              break;
            case 'Error Text':
              transText = trans.requiredErrorText || '';
              break;
            case 'Placeholder':
              transText = trans.placeHolderText || '';
              break;
            default:
              transText = (typeof trans === 'string') ? trans : (trans.text || trans.value || '');
          }

          normalizedTranslations[lang] = { text: transText };
        });
      }

      items.push({
        type,
        id: question.id,
        tempId: question.tempId,
        optionId,
        originalText: displayText,
        translations: normalizedTranslations,
        isError
      });

      // console.log(items, 'items in addTextItem');
    };

    addTextItem('Question', question.questionText, question.translations);
    addTextItem('Question Description', question.questionDescription, question.translations);
    addTextItem('Error Text', question.requiredErrorText, question.translations, true);
    addTextItem('Placeholder', question.placeHolderText, question.translations);

    if (question.choices) {
      if (typeof question.choices[0] === 'string') {
        question.choices[0].split(',').forEach((choice, index) => {
          addTextItem('Option', choice.trim(), question.translations, false, `opt-${index}`);
        });
      } else {
        question.choices.forEach((option, index) => {
          if (!option.id && !option.text && !option.value) return;
          addTextItem(
            'Option',
            option.text || option.value,
            option.translations || question.translations,
            false,
            option.tempId || `opt-${index}`
          );
        });
      }
    }

    if (question.rows) {
      question.rows.forEach((row, index) => {
        addTextItem(
          'Row',
          typeof row === 'string' ? row : row.text || row.value,
          question.rowTranslations?.[index] || question.translations,
          false,
          `row-${index}`
        );
      });
    }

    if (question.columns) {
      question.columns.forEach((col, index) => {
        addTextItem(
          'Column',
          typeof col === 'string' ? col : col.text || col.value,
          question.columnTranslations?.[index] || question.translations,
          false,
          `col-${index}`

        );
      });
    }

    return items;
  };

  return {
    updatedData,
    updatedLanguageList,
    allTextItems: updatedData.flatMap(question => getQuestionTextItems(question))
  };
  
}, [mergedSurveyData]);


    const back = () => {
        dispatch(displayTranlslationPage(false));
    };
  const generateMultiLanguageTemplate = useCallback(() => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Translations');

    // Use the same language list as shown in UI (excluding English)
    const languages = updatedLanguageList.filter(lang => lang !== 'English');

    // Set columns to match UI structure exactly
    worksheet.columns = [
        { header: 'Question ID', key: 'questionId', width: 15 },
        { header: 'Question/Option', key: 'textType', width: 20 },
        { header: 'English (Default)', key: 'originalText', width: 40 },
        ...languages.map(lang => ({
            header: `${lang}`,
            key: lang,
            width: 40
        }))
    ];

    // Process all text items exactly as they appear in UI
    allTextItems.forEach(textItem => {
        const row = {
            questionId: textItem.tempId,
            textType: textItem.type,
            originalText: textItem.originalText
        };

        // Add translations for each language - using the same logic as UI display
        languages.forEach(lang => {
            // Find the matching language key (case insensitive)
            const langKey = Object.keys(textItem.translations).find(
                key => key.toLowerCase() === lang.toLowerCase()
            );

            if (langKey) {
                // Get the translation exactly as shown in UI
                row[lang] = textItem.translations[langKey].text || '';
            } else {
                row[lang] = '';
            }
        });

        worksheet.addRow(row);
    });

    return workbook;
}, [allTextItems, updatedLanguageList]);

    const handleDownloadTemplate = useCallback(async () => {
        try {
            const workbook = generateMultiLanguageTemplate();
            const buffer = await workbook.xlsx.writeBuffer();

            const url = URL.createObjectURL(new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }));

            const link = document.createElement('a');
            link.href = url;
            link.download = `translations_template_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error('Error generating template:', error);
        }
    }, [generateMultiLanguageTemplate]);

    const handleFileUpload = useCallback(async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const buffer = e.target.result;
                const workbook = new ExcelJS.Workbook();
                await workbook.xlsx.load(buffer);

                const worksheet = workbook.getWorksheet('Translations');
                if (!worksheet) {
                    throw new Error('Translations sheet not found');
                }

                const languages = [];
                worksheet.getRow(1).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    if (colNumber > 3) {
                        const lang = cell.value?.toString();
                        if (lang) languages.push(lang);
                    }
                });

                const translationsPayload = {
                    pages: []
                };

                for (let rowNumber = 2; rowNumber <= worksheet.rowCount; rowNumber++) {
                    const row = worksheet.getRow(rowNumber);

                    const questionId = row.getCell(1).value?.toString();
                    const type = row.getCell(2).value?.toString();
                    const originalText = row.getCell(3).value?.toString();

                    if (!questionId || !type || !originalText) continue;
                    //console.log(`Processing row ${rowNumber}:`, { questionId, type, originalText });
                    let question = null;
                    for (const page of mergedSurveyData.pages) {
                        question = page.elements.find(q => q.tempId?.toString() === questionId);
                        if (question) break;
                    }
                    if (!question) continue;

                    let pageInPayload = translationsPayload.pages.find(p =>
                        p.id?.toString() === questionId ||
                        p.tempId === question.tempId
                    );

                    if (!pageInPayload) {
                        pageInPayload = {
                            id: question.id,
                            tempId: question.tempId,
                            translations: {}
                        };
                        translationsPayload.pages.push(pageInPayload);
                    }

                    languages.forEach((lang, index) => {
                        const cell = row.getCell(index + 4);
                        const cellValue = cell.value?.toString()?.trim();

                        if (!pageInPayload.translations[lang]) {
                            pageInPayload.translations[lang] = {};
                        }

                        const valueToSet = cellValue !== undefined && cellValue !== '' ? cellValue : originalText;

                        switch (type) {
                            case 'Question':
                                pageInPayload.translations[lang].questionText = valueToSet;
                                break;
                            case 'Question Description':
                                pageInPayload.translations[lang].questionDescription = valueToSet;
                                break;
                            case 'Error Text':
                                pageInPayload.translations[lang].requiredErrorText = valueToSet;
                                break;
                            case 'Placeholder':
                                pageInPayload.translations[lang].placeHolderText = valueToSet;
                                break;
                            case 'Option':
                                if (question.choices) {
                                    if (!pageInPayload.translations[lang].choices) {
                                        pageInPayload.translations[lang].choices = [];
                                    }

                                    const option = question.choices.find(opt =>
                                        (opt.text === originalText || opt.value === originalText)
                                    );

                                    if (option) {
                                        let optionTranslation = pageInPayload.translations[lang].choices.find(
                                            t => t.text === originalText || t.value === originalText
                                        );

                                        if (!optionTranslation) {
                                            optionTranslation = {
                                                text: valueToSet,
                                                value: option.value || option.text,
                                                tempId: option.tempId || question.tempId
                                            };
                                            pageInPayload.translations[lang].choices.push(optionTranslation);
                                        } else {
                                            optionTranslation.text = valueToSet;
                                        }
                                    }
    }
    break;
                        }
                    });
                }

                const postObject = {
                    survey_id: currentSurveyID,
                    user_id: userLoginDetails.user_id,
                    survey_translation: JSON.stringify(translationsPayload)
                };
              
                await dispatch(SaveSurveyTranslation(postObject));
                await dispatch(TransactionListByID(`${currentSurveyID}/${userLoginDetails.user_id}`));

            } catch (error) {
                console.error('Error processing translations file:', error);
            } finally {
                event.target.value = '';
            }
        };
        reader.readAsArrayBuffer(file);
    }, [mergedSurveyData, currentSurveyID, userLoginDetails.user_id, dispatch]);

    return (
        <div className="row">
            <div className="col-1"></div>
            <div className="col-10"
                style={{
                    border: '1px solid #d3caca',
                    borderRadius: '10px',
                    backgroundColor: 'white',
                    color: 'black',
                    margin: '7px',
                }}
            >
                <div className="d-flex justify-content-between py-3">
                    <div className="col-md-auto">
                        <div className="row align-items-center" style={{ fontWeight: 'bold', margin: 0 }}>
                            <div className="col-md-auto">
                                <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Translate Survey Questionnaire</span>
                             <i
                                className="fa-solid fa-circle-info ms-2"
                                data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                title="This section allows translation of the survey questionnaire. If a field is not translated, the English version will be used by default"                   
                                style={{ cursor: 'pointer', fontSize: '18px' }}
                                ></i>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2 justify-content-md-end justify-content-center" style={{ textAlign: 'right' }}>
                        <Button
                            name="Back"
                            label="Back"
                            className="back-button-style"
                            icon="pi pi-arrow-left"
                            onClick={back}
                        />
                        <Button
                            name="downloadTemplate"
                            label="Template"
                            className="download-button-style"
                            onClick={handleDownloadTemplate}
                            icon="pi pi-download"
                            tooltip="Click to download translation template .xlsx file"
                            tooltipOptions={{ position: 'bottom' }}
                            style={{ fontSize: '12px', padding: '6px 5px' }}
                        />
                        <Button
                            name="uploadRespondents"
                            label="Upload"
                            className="upload-button-style"
                            icon="pi pi-upload"
                            tooltip="Click to upload updated translation template .xlsx file"
                            tooltipOptions={{ position: 'bottom' }}
                            style={{ fontSize: '12px', padding: '6px 5px' }}
                            onClick={() => document.getElementById('file-upload').click()}
                        />
                        <input
                            type="file"
                            id="file-upload"
                            accept=".xlsx"
                            style={{ display: 'none' }}
                            onChange={handleFileUpload}
                        />
                    </div>
                </div>

                <div className="mb-2 mt-1" style={{ backgroundColor: 'black', height: 1 }}></div>

                <div style={{ overflowX: 'auto', maxHeight: '60vh', borderTop: '1px solid #ccc' }}>
                    <div className="d-flex py-2" style={{
                        backgroundColor: '#f2f2f2',
                        minWidth: 'fit-content',
                        whiteSpace: 'nowrap',
                        position: 'sticky',
                        top: 0,
                        zIndex: 1
                    }}>
                        <div style={{ minWidth: '150px' }}><b>Question ID</b></div>
                        <div style={{ minWidth: '200px' }}><b>Question/Option</b></div>
                        <div style={{ minWidth: '300px' }}><b>English (Default)</b></div>
                        {updatedLanguageList.filter(lang => lang !== 'English').map(lang => (
                            <div key={lang} style={{ minWidth: '300px' }}><b>{lang}</b></div>
                        ))}
                    </div>

                    {allTextItems.map((item, index) => (
                        
                        <div
                            key={`${item.id}-${item.type}-${index}`}
                            className="d-flex py-2 align-items-center"
                            style={{
                                backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2',
                                minWidth: 'fit-content',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <div style={{ minWidth: '150px' }}>{item.tempId}</div>
                            <div style={{ minWidth: '200px', 
                                   color:  item.isError || item.type === 'Error Text' ? '#bd3434' : 
                                        item.type === 'Placeholder' ? 'rgb(31, 59, 179)' : 
                                        'inherit'
                            }}>{item.type}</div>
                            <div style={{
                                minWidth: '300px',
                                color: item.isError ? '#bd3434' :    item.type === 'Placeholder' ? 'rgb(31, 59, 179)' : 
                                        'inherit'
                            }}>
                                {item.originalText}
                            </div>

                            {updatedLanguageList.filter(lang => lang !== 'English').map(lang => {
                                const langKey = Object.keys(item.translations).find(
                                    key => key.toLowerCase() === lang.toLowerCase()
                                );

                                const translation = langKey ? item.translations[langKey] : null;

                                return (
                                      <div
                                        key={lang}
                                        style={{
                                        minWidth: '300px',
                                        color: item.isError ? '#bd3434' : item.type === 'Placeholder' ? 'rgb(31, 59, 179)' : 'inherit'
                                        }}
                                    >
                                        {translation?.text || ''}
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
            <div className='col-1'></div>
        </div>
    );
};

export default EditTranslations;